import React, { useState } from 'react'

// Bloque "extra" para plantillas CaixaBank: muestra a quién se le cerrará el flujo
// cuando se procese el Excel (duplicados en campañas abiertas + pagados por
// SEGUIMIENTO REG_TRA_7D=1). Se alimenta del `preview` (dryRun) de /process-excel.
// Se muestra tanto en el paso Upload como en el de Send para que el flujo sea el
// mismo que el de CSV, solo que con este detalle añadido.
const ExcelClosingSummary = ({ preview }) => {
  const [showWho, setShowWho] = useState(false)

  if (!preview) return null

  const seguimiento = preview.seguimientoClosedList || []
  const duplicates = preview.duplicatePhonesList || []
  const totalClosed =
    (preview.flowsClosed || 0) + (preview.duplicateFlowsClosed || 0)

  if (totalClosed === 0) {
    return (
      <div className="mt-4 rounded-md bg-gray-50 border border-gray-200 p-4 text-sm text-gray-600">
        Excel CaixaBank detectado. No se cerrará ningún flujo con este fichero.
      </div>
    )
  }

  return (
    <div className="mt-4 rounded-md bg-red-50 border border-red-200 p-4">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-red-800">
          Se cerrarán <span className="font-bold">{totalClosed}</span> flujo(s)
          al procesar el Excel
        </p>
        {(seguimiento.length > 0 || duplicates.length > 0) && (
          <button
            type="button"
            onClick={() => setShowWho((v) => !v)}
            className="text-xs font-medium text-red-700 underline hover:text-red-900"
          >
            {showWho ? 'Ocultar' : 'Ver a quién'}
          </button>
        )}
      </div>
      <p className="mt-1 text-xs text-red-600">
        {preview.flowsClosed || 0} ya pagados (SEGUIMIENTO · REG_TRA_7D=1)
        {(preview.duplicateFlowsClosed || 0) > 0
          ? ` · ${preview.duplicateFlowsClosed} duplicados en campañas abiertas`
          : ''}
      </p>

      {showWho && (
        <div className="mt-3 space-y-3">
          {seguimiento.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-red-700">
                Pagados (SEGUIMIENTO):
              </p>
              <ul className="mt-1 max-h-40 overflow-auto text-xs text-red-800">
                {seguimiento.map((c, i) => (
                  <li key={`s-${i}`} className="py-0.5">
                    {c.phone}
                    {c.name ? ` — ${c.name}` : ''}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {duplicates.length > 0 && (
            <div>
              <p className="text-xs font-semibold text-red-700">
                Duplicados (ya en otra campaña abierta):
              </p>
              <ul className="mt-1 max-h-40 overflow-auto text-xs text-red-800">
                {duplicates.map((p, i) => (
                  <li key={`d-${i}`} className="py-0.5">
                    {typeof p === 'string' ? p : p.phone}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ExcelClosingSummary
